import { formatCNPJ } from '@format/CNPJ';
import { Grid } from '@material-ui/core';
import React from 'react';
import TextInput from './TextInput';

const CnpjInput = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  touched,
  error,
  variant,
  required = false,
  disabled = false,
  size = 6,
}) => {
  return (
    <Grid item xs={size}>
      <TextInput
        id={id}
        name={name}
        label={label}
        value={formatCNPJ(value)}
        onChange={onChange}
        onBlur={onBlur}
        maxLength={18}
        touched={touched}
        error={error}
        required={required}
        disabled={disabled}
        variant={variant}
      />
    </Grid>
  );
};

export default CnpjInput;
